import { Controller } from "@hotwired/stimulus"

// Submits a search form as you type, a moment after the last keystroke.
// Connects to data-controller="search"
export default class extends Controller {
  // The id of the "searching" indicator to show while a search is in flight.
  static values = { loading: String, delay: { type: Number, default: 300 } }

  connect() {
    this.boundSubmissionEnd = this.submissionEnd.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundSubmissionEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.boundSubmissionEnd)
    // A search still waiting to be sent must not fire on the next page.
    clearTimeout(this.timer)
  }

  submit() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.loadingArea?.classList.remove("hidden")
      this.element.requestSubmit()
    }, this.delayValue)
  }

  submissionEnd() {
    this.loadingArea?.classList.add("hidden")
    this.element.querySelector("[name='text_query']")?.focus()
  }

  get loadingArea() {
    return document.getElementById(this.loadingValue)
  }
}
